import { create } from 'zustand';
import { User } from 'firebase/auth';

interface SyncState {
  user: User | null;
  authLoading: boolean;
  syncLoading: boolean;
  error: Error | null;
  lastSyncedAt: number | null;
  syncStatus: 'idle' | 'syncing' | 'error' | 'success';
}

interface SyncStore extends SyncState {
  setUser: (user: User | null) => void;
  setAuthLoading: (loading: boolean) => void;
  setSyncLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  setLastSyncedAt: (time: number | null) => void;
  setSyncStatus: (status: SyncState['syncStatus']) => void;
  // Combined updates for better performance
  setSyncState: (partialState: Partial<SyncState>) => void;
  resetSyncState: () => void;
}

export const useSyncStore = create<SyncStore>(set => ({
  // Initial state
  user: null,
  authLoading: true,
  syncLoading: false,
  error: null,
  lastSyncedAt: null,
  syncStatus: 'idle',

  // Individual setters
  setUser: user => {
    set({ user });
  },
  setAuthLoading: authLoading => {
    set({ authLoading });
  },
  setSyncLoading: syncLoading => {
    set({ syncLoading });
  },
  setError: error => {
    set({ error });
  },
  setLastSyncedAt: lastSyncedAt => {
    set({ lastSyncedAt });
  },
  setSyncStatus: syncStatus => {
    set({ syncStatus });
  },

  // Combined updates
  setSyncState: partialState => {
    set(state => ({ ...state, ...partialState }));
  },
  resetSyncState: () => {
    set({
      user: null,
      authLoading: false,
      syncLoading: false,
      error: null,
      lastSyncedAt: null,
      syncStatus: 'idle',
    });
  },
}));
